/**
 * TCoinIcon — inline T-Coin currency icon.
 * Renders the gold coin image at the specified size,
 * vertically centered with surrounding text.
 */
export default function TCoinIcon({ size = 16, style }: { size?: number; style?: React.CSSProperties }) {
    return (
        <img
            src="/icons/tcoin.png"
            alt="T"
            width={size}
            height={size}
            style={{
                display: 'inline-block',
                verticalAlign: 'middle',
                objectFit: 'contain',
                marginRight: 2,
                ...style,
            }}
        />
    );
}
